
    import '/opt/buildhome/repo/packages/x/docs/x-markdown/components-sources.zh-CN.md?watch=parent';
    export const demoIndex = {
  ids: ["docs-x-markdown-components-sources-demo-sources"],
  getter: () => import(/* webpackChunkName: "meta__docs__zh-CN" */'/opt/buildhome/repo/packages/x/docs/x-markdown/components-sources.zh-CN.md?type=demo')
};